import type { DefaultTheme } from "react-jss";
import type { DeepPartial } from "ts-essentials";
import * as z from "zod";

import type { BaseTheme } from "./baseTheme";

export const ThemeKeySchema = z.enum([
  "VAPIANO",
  "OLEARYS",
  "BLENDER",
  "MYSUSHI",
  "APOLLO_CINEMA_EE",
  "APOLLO_CINEMA_LT",
  "FORUM_CINEMAS_LT",
  "KFC",
  "URBAN_KITCHEN",
  "CITY_EXPRESS",
  "APOLLO_FOOD_TRUCK",
]);
export type ThemeKey = z.infer<typeof ThemeKeySchema>;

export const ThemeVariantSchema = z.enum(["LIGHT", "DARK"]);
export type ThemeVariant = z.infer<typeof ThemeVariantSchema>;

export const ThemeCountrySchema = z.enum(["EE", "LT"]);
export type ThemeCountry = z.infer<typeof ThemeCountrySchema>;

export type ThemeVariantMap<T = DefaultTheme> = Partial<
  Record<ThemeVariant, T>
>;

export type ThemeCountryMap<T = DefaultTheme> = Partial<
  Record<ThemeCountry, T>
>;

export const asPartialTheme = <T extends DeepPartial<BaseTheme>>(
  partialTheme: T,
) => partialTheme;
